import { UserTag } from 'types/auth';

/**
 * Adds Ingrid attributes.
 * @function
 * @param {UserTag[]} userTags - An array of user tags.
 * @param {boolean} member - A boolean that determines if the user is a member.
 * @param {string[]} rest - An array of tags.
 * @returns {string[]} - An array containing all tags as strings.
 *
 * Example usage:
 * const userTags = [{ name: 'ACT' }];
 * const isMember = true;
 * const rest = ['johaug', 'no'];
 *
 * Output: ['johaug', 'no', 'member', 'ACT']
 *
 */
const addIngridAttributes = (userTags?: UserTag[], member = false, ...rest: string[]): string[] => {
    const ingridAttributes: string[] = [...rest];

    if (member) {
        ingridAttributes.push('member');
    }

    if (userTags?.length) {
        userTags.forEach(({ name }) => ingridAttributes.push(name));
    }

    return ingridAttributes.filter(string => string);
};

export default addIngridAttributes;
